import { render, staticRenderFns } from "./StoryDefaultTemplate.vue?vue&type=template&id=446c7655&scoped=true&"
import script from "./StoryDefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./StoryDefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StoryDefaultTemplate.vue?vue&type=style&index=0&id=446c7655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c7655",
  null
  
)

export default component.exports